module.exports = __webpack_public_path__ + "img/profile-privacy.6a9fb01d.jpg";